// Fixture para datos de CUPS tarifarios en modo desarrollo
export const cupsTarifariosFixture = {
  "ResponseCode": 200,
  "ResponseDetail": "Ok",
  "Result": {
    "__type": "AcuerdosTarifariosCupsResponse:#Consorcio.Transar.Entities.Common.Response",
    "Columnas": [
      {
        "Atributo": "Cups",
        "Nombre": "CUPS",
        "Orden": 1
      },
      {
        "Atributo": "Descripcion",
        "Nombre": "Descripción",
        "Orden": 2
      },
      {
        "Atributo": "Tarifa",
        "Nombre": "Tarifa",
        "Orden": 3
      },
      {
        "Atributo": "HonorariosProfesionales",
        "Nombre": "Honorarios Profesionales",
        "Orden": 4
      },
      {
        "Atributo": "TarifaBogotaYBoyaca",
        "Nombre": "Tarifa Bogotá y Boyacá",
        "Orden": 5
      },
      {
        "Atributo": "TarifaDiaria",
        "Nombre": "Tarifa diaria",
        "Orden": 6
      }
    ],
    "Cups": [
      {
        "Id": 1381339,
        "Estado": "Pendiente",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814562" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 1" },
          { "Atributo": "Tarifa", "Valor": "3245" },
          { "Atributo": "HonorariosProfesionales", "Valor": "3245" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "3245" },
          { "Atributo": "TarifaDiaria", "Valor": "3245" }
        ]
      },
      {
        "Id": 1381340,
        "Estado": "Aprobado",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814563" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 2" },
          { "Atributo": "Tarifa", "Valor": "3245" },
          { "Atributo": "HonorariosProfesionales", "Valor": "3245" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "3245" },
          { "Atributo": "TarifaDiaria", "Valor": "3245" }
        ]
      },
      {
        "Id": 1381341,
        "Estado": "Pendiente",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814564" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 3" },
          { "Atributo": "Tarifa", "Valor": "5200" },
          { "Atributo": "HonorariosProfesionales", "Valor": "4850" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "5200" },
          { "Atributo": "TarifaDiaria", "Valor": "1200" }
        ]
      },
      {
        "Id": 1381342,
        "Estado": "Rechazado",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814565" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 4" },
          { "Atributo": "Tarifa", "Valor": "7800" },
          { "Atributo": "HonorariosProfesionales", "Valor": "6200" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "7800" },
          { "Atributo": "TarifaDiaria", "Valor": "2100" }
        ]
      },
      {
        "Id": 1381343,
        "Estado": "Pendiente",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814566" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 5" },
          { "Atributo": "Tarifa", "Valor": "4500" },
          { "Atributo": "HonorariosProfesionales", "Valor": "4200" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "4500" },
          { "Atributo": "TarifaDiaria", "Valor": "950" }
        ]
      },
      {
        "Id": 1381344,
        "Estado": "Aprobado",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814567" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 6" },
          { "Atributo": "Tarifa", "Valor": "6700" },
          { "Atributo": "HonorariosProfesionales", "Valor": "5900" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "6700" },
          { "Atributo": "TarifaDiaria", "Valor": "1800" }
        ]
      },
      {
        "Id": 1381345,
        "Estado": "Pendiente",
        "Valores": [
          { "Atributo": "Cups", "Valor": "814568" },
          { "Atributo": "Descripcion", "Valor": "Descripción del CUPS 7" },
          { "Atributo": "Tarifa", "Valor": "9200" },
          { "Atributo": "HonorariosProfesionales", "Valor": "8100" },
          { "Atributo": "TarifaBogotaYBoyaca", "Valor": "9200" },
          { "Atributo": "TarifaDiaria", "Valor": "2500" }
        ]
      }
    ],
    "TotalAprobados": 0,
    "TotalCups": 7,
    "TotalPendientes": 7,
    "TotalRechazados": 0
  }
};